export const OPEN_DRAWER = 'OPEN_DRAWER'
export const CLOSE_DRAWER = 'CLOSE_DRAWER'

const openDrawer = drawerProps => ({
    type: OPEN_DRAWER,
    drawerProps
  })

const closeDrawer = () => ({
    type: CLOSE_DRAWER
  })

export default function drawerReducer(state, action = {}) {
  const currentState = state === undefined ? { open: false } : state

  switch (action.type) {
    case OPEN_DRAWER:
      return { open: true, className: 'universal-drawer', ...action.drawerProps }
    case CLOSE_DRAWER:
      return { open: false }
    default:
      return currentState
  }
}

export const drawerActions = {
  openDrawer,
  closeDrawer
}
